import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-map-sidebar-group-header',
  templateUrl: './map-sidebar-group-header.component.html',
  styleUrls: ['./map-sidebar-group-header.component.scss']
})
export class MapSidebarGroupHeaderComponent implements OnInit {

  @Input()
  group: any;

  constructor() {
  }

  ngOnInit(): void {
  }

}
